import { ConfirmDialog, SubmitDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';
import { Grid, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

export const MoveSnapDrawPhotos = observer(({ loanId, drawId, afterActionExecuted }) => {

  const { drawStore: { drawActionsStore } } = useDrawsStore();

  const onAutoCompleteChange = (_, value) => {
    drawActionsStore.setTruepicEvent(getEventByValue(value));
    drawActionsStore.setTruepicOption(value);
  };

  const getEventByValue = (value) => {
    if (!value) return null;
    const values = value.split(" loan ID ");
    const values1 = values[1];
    const loanDraw = values1.split(" draw # ");
    const event = {
      truepicId: values[0],
      primaryId: loanDraw[0],
      drawNumber: loanDraw[1]
    }
    return event;
  };

  const confirmHandler = () => {
    drawActionsStore.movePictures(drawId, afterActionExecuted);
  }

  return (
    <>
      <SubmitDialog
        title="Move Snap Draws Photos to this Draw"
        open={drawActionsStore.isMoveSnapDrawsPhotosDialogOpen}
        body={
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                variant='body1'
                component='body'
                gutterBottom>
                {
                  drawActionsStore.inspectionOpen ?
                    "There's an open snap draws request for this draw, if you chose a new one it will get closed." :
                    'No snap draws requests are currently open for this draw.'
                }
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                id='truepicEvents'
                options={drawActionsStore.truepicEventList}
                componentName="truepicEvents"
                renderInput={(options) => <TextField {...options} />}
                onInputChange={(label, value) => onAutoCompleteChange("", value)}
              />
            </Grid>
          </Grid>
        }
        handleClose={() => drawActionsStore.setIsMoveSnapDrawsPhotosDialogOpen(false)}
        handleOk={() => drawActionsStore.moveTruepicPhotos()}
        cancelButtonText='Cancel'
      />
      <ConfirmDialog
        open={drawActionsStore.isTruepicConfirmDialogOpen}
        confirmButtonText='Confirm'
        handleClose={() => drawActionsStore.setIsTruepicConfirmDialogOpen(false)}
        handleCancel={() => drawActionsStore.setIsTruepicConfirmDialogOpen(false)}
        handleConfirm={confirmHandler}
        title={'Move Truepic Photos'}
        body={`Are you sure you want to move pictures from loan ID ${drawActionsStore.truepicEvent?.primaryId} and draw #${drawActionsStore.truepicEvent?.drawNumber} to this draw?`}
      />
    </>
  );
});
